import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import Sidebar from './Sidebar'
import EmailVerificationBanner from '@/components/ui/EmailVerificationBanner'
import DocumentVerificationBanner from '@/components/ui/DocumentVerificationBanner'
import AccountStatusBanner from '@/components/ui/AccountStatusBanner'
import { ChatWidget } from '@/components/chat'
import { useAuth } from '@/contexts/AuthProvider'
import { useGlobalChat } from '@/contexts/ChatContext'
import useScrollToTop from '@/hooks/useScrollToTop'

const Layout: React.FC = () => {
    useScrollToTop()
    const location = useLocation()
    const { user, isAuthenticated } = useAuth()
    const { isOpen: chatIsOpen, openChat, closeChat } = useGlobalChat()
    const showSidebar = location.pathname !== '/'
    const isDashboardRoute = location.pathname.startsWith('/dashboard')

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
            <Header />
            <EmailVerificationBanner />
            <DocumentVerificationBanner />
            {isAuthenticated && user && (
                <div className="px-4 sm:px-6 lg:px-8 space-y-4">
                    <AccountStatusBanner user={user} />
                </div>
            )}

            <div className="flex-1 flex">
                {/* Sidebar */}
                {showSidebar && <Sidebar />}

                {/* Main Content */}
                <main className="flex-1 transition-all duration-300 ease-in-out overflow-hidden">
                    <div
                        className={`max-w-7xl mx-auto min-w-0 ${
                            isDashboardRoute
                                ? 'px-3 sm:px-6 lg:px-8 py-4 sm:py-6'
                                : 'px-4 sm:px-6 lg:px-8 py-6'
                        }`}
                    >
                        <div className="w-full max-w-none min-w-0">
                            <Outlet />
                        </div>
                    </div>
                </main>
            </div>

            <Footer />

            {/* Live Chat Widget - Available for authenticated users */}
            {isAuthenticated && (
                <ChatWidget 
                    isControlled={true}
                    controlledIsOpen={chatIsOpen}
                    onOpen={openChat}
                    onClose={closeChat}
                />
            )}
        </div>
    )
}

export default Layout